// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"854":"pdfjs","986":"pdfjs-legacy"}[chunkId] || chunkId) + "." + {"488":"f956f7f8","854":"24026867","986":"79669655"}[chunkId] + ".chunk.js";
};